<template>
  <div class="bdt-text-input">
    <label v-if="label" :for="id">
      <span> {{ label }} </span>
      <span v-if="required" class="text-error"> {{ required ? '*' : '' }} </span>
    </label>
    <div class="allow-inner-icon">
      <span class="icon" v-if="icon">
        <Icon
          :name="icon"
          :class="{
            'fill-outline': !isInputFocused && isInputEmpty,
            'fill-on-surface': isInputFocused || !isInputEmpty,
            'fill-error': error,
          }"
        />
      </span>
      <input
        :id="id"
        :name="id"
        ref="input"
        v-bind="$attrs"
        :required="required"
        :type="type"
        :placeholder="placeholder"
        :class="['', { 'input-error': error }]"
        :value="value"
        @input="handleInput($event)"
        @focus="isInputFocused = true"
        @blur="isInputFocused = false"
      />
    </div>
    <div class="helper-text">
      <small v-if="error" class="text-error"> {{ error }} </small>
      <small v-else-if="hint"> {{ hint }}</small>
    </div>
    <!-- <div v-else-if="hint" class="d-block fw-light text-secondary lh-1 mb-1 fs-6">
    </div> -->
  </div>
</template>

<script>
import Icon from '@/Components/Icon'

export default {
  inheritAttrs: false,
  components: { Icon },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
    },
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return ['url', 'text', 'password', 'tel', 'search', 'number', 'email', 'date'].includes(
          value,
        )
      },
    },
    placeholder: {
      type: String,
      default() {
        return this.type === 'password'
          ? '\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217'
          : ''
      },
    },
    value: {
      type: null,
      default: '',
    },
    icon: String,
    icon_color: String,
    hint: String,
  },
  data() {
    return {
      isInputFocused: false,
      isInputEmpty: true,
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    handleInput(event) {
      this.isInputEmpty = event.target.value.length == 0
      this.$emit('input', event.target.value)
    },
  },
}
</script>
